import axios from 'axios';

const resource = '/protocolo-api/actuator/info';

export const getInfo = () => {
  return axios.get(resource);
};
